import { extractDate } from '../JobHistory';

type Props = {
  date: string;
  className?: string;
};

export function FormatedDate({ date, className }: Props) {
  const tDay = new Date();
  const today = extractDate(tDay.toISOString());
  const yDay = new Date();
  yDay.setDate(yDay.getDate() - 1);
  const yesterday = extractDate(yDay.toISOString());

  if (extractDate(date) === today) {
    return <h3 className={className ?? ''}>Today</h3>;
  } else if (extractDate(date) === yesterday) {
    return <h3 className={className ?? ''}>Yesterday</h3>;
  }
  return <h3 className={className ?? ''}>{extractDate(date)}</h3>;
}
